<template>
	<section class="text-align-center bg-color-greige marketing-section">
		<div class="container">
			<div class="col-8-md col-offset-2-md">
				<h2 class="label-sm text-transform-uppercase text-color-content-secondary">historical stability</h2>
				<h3 class="heading-xl mt-150"> How Fundrise compares to public REITs </h3>
				<p class="body-md mt-150 px-150-lg">
					Private real estate has historically shown less volatility compared to public REITs (real estate
					investment trusts). While public REITs are subject to market and sentiment-driven fluctuations,
					private real estate has been steady in comparison — exhibiting more smooth and gradual growth
					overall.
				</p>

				<AnnualReturnsTable
					:full-width="true"
					table-classes="table-container px-100 pb-100 pt-150 bg-color-white my-250"
				>
					<template #chart_footer>
						<p class="mt-150 mt-200-md text-align-center muted eta">
							<BaseButton classes="text-link muted" @click="openModal()"> Learn more</BaseButton>
							about the assumptions in this section. The foregoing performance information is presented
							solely with regard to the advisory client performance of the clients of Fundrise Advisors,
							LLC pursuant to the Investment Advisers Act of 1940, and does not represent the performance
							of any individual investor or any individual or aggregate performance of any funds with
							offerings qualified pursuant Regulation A of the Securities Act (the "Regulation A Funds").
							For more information about the Regulation A Funds, and their corresponding Forms 1-A,
							including their individual performance information, please click
							<BaseButton classes="text-link muted" @click="openDisclaimerModal()"> here</BaseButton>.
						</p>
					</template>
				</AnnualReturnsTable>
			</div>
		</div>
	</section>
</template>
<script setup lang="ts">
import AnnualReturnsTable from '@components/charts/annual-returns-table.vue';
import { CurrentModal } from 'types/modal';
import DisclaimerSimple from '@components/disclaimer/disclaimer-simple.vue';
import { reactive } from 'vue';
import { regAFundListing } from '@constants/marketing-site';
import { useAppStore } from '@stores/app';

interface Emits {
	(e: 'open-modal'): void;
}

const emit = defineEmits<Emits>();

const appStore = useAppStore();

function openModal(): void {
	emit('open-modal');
}

function openDisclaimerModal(): void {
	const modal: CurrentModal = reactive({
		modal: DisclaimerSimple,
		props: regAFundListing
	});
	appStore.updateCurrentModal(modal);
}
</script>
